import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import usePDF from 'app/hooks/usePDF';
import { SectionSuccess } from './styles';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userSessionId: PropTypes.string
    }).isRequired
  }).isRequired,

  render: PropTypes.func.isRequired,
  clearSession: PropTypes.func.isRequired
};

const Success = ({
  match: {
    params: { userSessionId }
  },

  render,
  clearSession
}) => {
  const fetchPDF = usePDF({ userSessionId });

  // eslint-disable-next-line
  useEffect(() => clearSession, []);

  return <SectionSuccess>{render({ fetchPDF })}</SectionSuccess>;
};

Success.propTypes = propTypes;
export default Success;
